[
  {
    "path": "app.json",
    "sha256": "sha256:8a58f9cabe884b51765f636755003be94497f9cc0fc2d657b997e5090ffad5d8"
  },
  {
    "path": "app.spec.json",
    "sha256": "sha256:17ecc34209e3da46c0384d58010615010978e30ef9db73ee4005da7e51f029f7"
  },
  {
    "path": "blocks/cart-view/data.json",
    "sha256": "sha256:ca3d163bab055381827226140568f3bef7eaac187cebd76878e0b63e9e442356"
  },
  {
    "path": "blocks/cart-view/events.json",
    "sha256": "sha256:28d754dde72259d073015ab37e8901b926d26f447385edceac14d8f891e678d6"
  },
  {
    "path": "blocks/cart-view/flow.json",
    "sha256": "sha256:70856bdf3a4358a3cb1e36a4fb64ca73dda6cc3f3e9ea49d27275c9922ff306b"
  },
  {
    "path": "blocks/cart-view/meta.json",
    "sha256": "sha256:d6fd502a10ba60289dee5e7b28f25f417bf8240fd2c6657cec1f98aa7098d1c5"
  },
  {
    "path": "blocks/cart-view/state.json",
    "sha256": "sha256:d974ce827899414603ce7e71ac2bdc2b7a2a80abf1ff833dc2d7d9280169a538"
  },
  {
    "path": "blocks/cart-view/ui.bindings.json",
    "sha256": "sha256:ceb714e121df4315368388237e8c6bceaa0a3fe29a76ada030dd4044a510bedc"
  },
  {
    "path": "blocks/cart-view/ui.json",
    "sha256": "sha256:380b9bcbb14bcaab41a0d2a8659803ceffcf994388c5a08ccdaeed7aed59fa47"
  },
  {
    "path": "blocks/cart-view/ui.template.json",
    "sha256": "sha256:ee99d5a14abc44f4006178ebeeedb671705007df66c6139fc2592155d0ef527a"
  },
  {
    "path": "blocks/checkout-form/data.json",
    "sha256": "sha256:ca3d163bab055381827226140568f3bef7eaac187cebd76878e0b63e9e442356"
  },
  {
    "path": "blocks/checkout-form/events.json",
    "sha256": "sha256:28d754dde72259d073015ab37e8901b926d26f447385edceac14d8f891e678d6"
  },
  {
    "path": "blocks/checkout-form/flow.json",
    "sha256": "sha256:f3acceb628d9151f9b3dfc398e0b9ff29ad1281c66b8ea5edf7aa0818f063a0f"
  },
  {
    "path": "blocks/checkout-form/meta.json",
    "sha256": "sha256:90d42c7a88f3739d91d0e7254313bd167c2a0d31c6fb8e087de37879279df099"
  },
  {
    "path": "blocks/checkout-form/state.json",
    "sha256": "sha256:660dbb27b7afc21214d7ee98b00bce5e45fefad4efb13232d08e389210f3cc52"
  },
  {
    "path": "blocks/checkout-form/ui.bindings.json",
    "sha256": "sha256:ad83350004761c0952886c276b75aeaa7342ff6eaf94b2985bc0bab9f59db350"
  },
  {
    "path": "blocks/checkout-form/ui.json",
    "sha256": "sha256:653dbcda7992705bb68610ff218b38745ef072d73e7d61db4e74ecdffac5f0a9"
  },
  {
    "path": "blocks/checkout-form/ui.template.json",
    "sha256": "sha256:38df051986dfe28209ab569e14294c44a0b7c916f44d23a625fb4231b660fe4b"
  },
  {
    "path": "blocks/hero-banner/data.json",
    "sha256": "sha256:ca3d163bab055381827226140568f3bef7eaac187cebd76878e0b63e9e442356"
  },
  {
    "path": "blocks/hero-banner/events.json",
    "sha256": "sha256:c79d6f60f2887aed731e63ebf1b1cbacd9b94819e9db58c3a61d6677c72b3b04"
  },
  {
    "path": "blocks/hero-banner/flow.json",
    "sha256": "sha256:a2069af663b4ddf991710251305a5092f9049b5576e4c208aef891e1d53c594e"
  },
  {
    "path": "blocks/hero-banner/meta.json",
    "sha256": "sha256:c609e2e52951946785ffaa9b49e8bd5b43baffcbb872cd1b84e40e03fdc6086c"
  },
  {
    "path": "blocks/hero-banner/state.json",
    "sha256": "sha256:1e0e656eca65ef3860c91216fdf34700b5fefd6a1d275eaa7dbbde4e73c3ed7f"
  },
  {
    "path": "blocks/hero-banner/ui.bindings.json",
    "sha256": "sha256:858fcbc400a9b7dbf2c4340b5b4960f5c5a82bddf146ee224595bb2df62e2e36"
  },
  {
    "path": "blocks/hero-banner/ui.json",
    "sha256": "sha256:5174c6b55af1ffaf569267395b5490e0ccbf48007cf2015927270b25b6ac3bce"
  },
  {
    "path": "blocks/hero-banner/ui.template.json",
    "sha256": "sha256:6a93b33c1dbfd4b2c55b79fb99f1f599a244b3ccaf60858a2615f3232b884dec"
  },
  {
    "path": "blocks/product-detail/data.json",
    "sha256": "sha256:ca3d163bab055381827226140568f3bef7eaac187cebd76878e0b63e9e442356"
  },
  {
    "path": "blocks/product-detail/events.json",
    "sha256": "sha256:28d754dde72259d073015ab37e8901b926d26f447385edceac14d8f891e678d6"
  },
  {
    "path": "blocks/product-detail/flow.json",
    "sha256": "sha256:5ec86f6a90bc698b28f06787c36524f13dd0425c324a34919b5ef864c325ece5"
  },
  {
    "path": "blocks/product-detail/meta.json",
    "sha256": "sha256:94f192aa8ec8b023be064709eac38892d126e874b9b52c11eec14acfd0daaeaf"
  },
  {
    "path": "blocks/product-detail/state.json",
    "sha256": "sha256:6cc62759c28ee0e10cb3f05e33bd81f464aa7e5c35511551739d292b49c4d8ae"
  },
  {
    "path": "blocks/product-detail/ui.bindings.json",
    "sha256": "sha256:11e61c421bd04d30eff9dd65765b3c0a0aa0e806a5511805f9a395a3de6157ff"
  },
  {
    "path": "blocks/product-detail/ui.json",
    "sha256": "sha256:ad96f3e61a61192a4f7624784472d830c01fb403e354173e38e42a9bf54796e0"
  },
  {
    "path": "blocks/product-detail/ui.template.json",
    "sha256": "sha256:d54c7b040acd5bd3cc35ae8c771d4a9e033df385ee3abb5e971cd638c7536ac2"
  },
  {
    "path": "blocks/product-grid/data.json",
    "sha256": "sha256:ca3d163bab055381827226140568f3bef7eaac187cebd76878e0b63e9e442356"
  },
  {
    "path": "blocks/product-grid/events.json",
    "sha256": "sha256:381cfa03b50ba8e3459d7a04f3c002e739f757c33a32b680ceda22fc0fc9dcbd"
  },
  {
    "path": "blocks/product-grid/flow.json",
    "sha256": "sha256:ca5a015e5e91e3749f8686bd7ea200046604e10f1adaceae778ca03a532b9ff7"
  },
  {
    "path": "blocks/product-grid/meta.json",
    "sha256": "sha256:11e67818ff4a2b38eb464e3fdc7f5e5be2e909f5bb1061a0a72d7e4451b2f067"
  },
  {
    "path": "blocks/product-grid/state.json",
    "sha256": "sha256:ad650fc730ede7a2481984c413dd88b7555a6d732754723b1c71d30f00976177"
  },
  {
    "path": "blocks/product-grid/ui.bindings.json",
    "sha256": "sha256:93277fdd83e5ea0ed74bf7cf1580a8168c4ad982df0de9b052754e4556e8e511"
  },
  {
    "path": "blocks/product-grid/ui.json",
    "sha256": "sha256:7328ee79d5e9a35854f403bb15e63024b0939da68294775444399dbe55e1268f"
  },
  {
    "path": "blocks/product-grid/ui.template.json",
    "sha256": "sha256:493a17f2a60189c3eb982e56ddc10db069d840d85c485e84e25f24ca7c29ad8b"
  },
  {
    "path": "blocks/store-footer/data.json",
    "sha256": "sha256:ca3d163bab055381827226140568f3bef7eaac187cebd76878e0b63e9e442356"
  },
  {
    "path": "blocks/store-footer/events.json",
    "sha256": "sha256:325dabe14fda29ad5f130cfbe79fe3571affb6ff4fd996fca26abaebec071989"
  },
  {
    "path": "blocks/store-footer/flow.json",
    "sha256": "sha256:1955f2a3825c1eed3b5ca95b1f0aa1f48f1d2bfd3ef33bb816710682f273159b"
  },
  {
    "path": "blocks/store-footer/meta.json",
    "sha256": "sha256:57b6c6463e7bc4566fa9c92928d41e51483f7e51180fef96bf96e8b6434a886b"
  },
  {
    "path": "blocks/store-footer/state.json",
    "sha256": "sha256:407fdf1b07cfc860f4f160ae62c71c5c14cfd14e389ade65dbfec2c75d4cab4c"
  },
  {
    "path": "blocks/store-footer/ui.bindings.json",
    "sha256": "sha256:045eff3594fd857eb4385e7f01ef95738632b2f42cca4aad4fa28551e045bb13"
  },
  {
    "path": "blocks/store-footer/ui.json",
    "sha256": "sha256:80daa80b1f1189dd5e4b95d68ca9ba0a2b32d7914619f1879bcfb80d39c4176b"
  },
  {
    "path": "blocks/store-footer/ui.template.json",
    "sha256": "sha256:ca067774c40acc838bc0505e5a99a7e509f1d83425511abbefc843d173550a6f"
  },
  {
    "path": "blocks/store-nav/data.json",
    "sha256": "sha256:ca3d163bab055381827226140568f3bef7eaac187cebd76878e0b63e9e442356"
  },
  {
    "path": "blocks/store-nav/events.json",
    "sha256": "sha256:ed8cd1b20022cd5a66d1f12a1e23206252e4f8b0c237fb246721f185894efcab"
  },
  {
    "path": "blocks/store-nav/flow.json",
    "sha256": "sha256:3f46d7cd2927458ed71465b2b6138187ed2c391760d369d3785d4abc3ce04479"
  },
  {
    "path": "blocks/store-nav/meta.json",
    "sha256": "sha256:0b1d3c98964c0f0d0d549410d55e92a8805d27a1f7c06a4f4f91f29565c9a699"
  },
  {
    "path": "blocks/store-nav/state.json",
    "sha256": "sha256:73c3c2aaf80dec493a93a7210058505ad91bb30d38e64cb85d36d09c6fe7a8fe"
  },
  {
    "path": "blocks/store-nav/ui.bindings.json",
    "sha256": "sha256:b3e9c1b89130d34f072f37fe3e907f60421ded1f76751e7a02bee4e17f92785d"
  },
  {
    "path": "blocks/store-nav/ui.json",
    "sha256": "sha256:bb192f5cf731a809f2199f731fad74c2ecabec091c521d93365bc89553bc9007"
  },
  {
    "path": "blocks/store-nav/ui.template.json",
    "sha256": "sha256:4efd64ed457f03d8b2d7b56dd669c03f7be0b9d4d4dcb543cd1b86c3fc379bcd"
  },
  {
    "path": "data/products.json",
    "sha256": "sha256:d993c62b043f75fa660a27ca98dd85adb96b18a43d5ff85d8ce6eec4ee0b56f8"
  },
  {
    "path": "design-system.json",
    "sha256": "sha256:60aaa0e360276a3132ce3ca87390a4fb5a3138f85162a5ba3c68f3d8198781f9"
  },
  {
    "path": "resources/theme-boutique.json",
    "sha256": "sha256:f1e5e39739ddc4785ed01ba55e4069b7ae1258d772104c8ca054156dc14a566f"
  },
  {
    "path": "resources/theme-brutalist.json",
    "sha256": "sha256:f1e5e39739ddc4785ed01ba55e4069b7ae1258d772104c8ca054156dc14a566f"
  },
  {
    "path": "resources/theme-default.json",
    "sha256": "sha256:9b0938a9a458520bdfd6183fe775d02839b746f74d9a2e6d51381c283f63fac4"
  },
  {
    "path": "resources/theme-minimal.json",
    "sha256": "sha256:f1e5e39739ddc4785ed01ba55e4069b7ae1258d772104c8ca054156dc14a566f"
  },
  {
    "path": "resources/theme-soft.json",
    "sha256": "sha256:f1e5e39739ddc4785ed01ba55e4069b7ae1258d772104c8ca054156dc14a566f"
  }
]
